module.exports = __webpack_public_path__ + "img/venuetwo-gift.308ff011.png";